<template>
  <div
    class="changeMapStyle"
    ref="changeMapStyle"
    @mouseleave="hideChangeMap"
    @mouseover="showChangeMap"
  >
    <a
      class="hybrid"
      @click="changeMapStyleF('hybrid')"
      :class="mapStyle === 'hybrid' ? 'changeMapOn' : ''"
      ref="hybrid"
    >
      <img :src="hybrid" />
    </a>
    <a
      class="normal"
      :class="mapStyle === 'normal' ? 'changeMapOn' : ''"
      @click="changeMapStyleF('normal')"
      ref="normal"
    >
      <img :src="normal" />
    </a>
    <a
      class="panorama"
      @click="changeMapStyleF('panorama')"
      :class="mapStyle === 'panorama' ? 'changeMapOn' : ''"
      ref="panorama"
    >
      <img :src="panorama" />
    </a>
  </div>
</template>

<script type="text/javascript">
import hybrid from "../../assets/img/map/hybrid.png";
import normal from "../../assets/img/map/normal.png";
import panorama from "../../assets/img/map/panorama.png";
export default {
  name: "MapStyle",
  data() {
    return {
      mapStyle: "hybrid",
      hybrid: hybrid, //卫星图
      normal: normal, //街道图
      panorama: panorama, //全景图
    };
  },
  methods: {
    changeMapStyleF(type) {
      this.$emit("changeMapStyle", type);
      if (type === "hybrid") {
        this.$refs.hybrid.style.zIndex = "999";
        this.$refs.normal.style.zIndex = "99";
        this.$refs.panorama.style.zIndex = "99";
      } else if (type === "normal") {
        this.$refs.hybrid.style.zIndex = "99";
        this.$refs.normal.style.zIndex = "999";
        this.$refs.panorama.style.zIndex = "99";
        this.$refs.hybrid.style.right = "14px";
      } else if (type === "panorama") {
        this.$refs.hybrid.style.zIndex = "99";
        this.$refs.normal.style.zIndex = "99";
        this.$refs.panorama.style.zIndex = "999";
      }
      this.mapStyle = type;
    },
    hideChangeMap: function (el) {
      this.$refs.changeMapStyle.style.width = "88px";
      this.$refs.hybrid.style.right = "12px";
      this.$refs.hybrid.style.top = "12px";
      this.$refs.normal.style.right = "12px";
      this.$refs.normal.style.top = "12px";
      this.$refs.panorama.style.right = "12px";
      this.$refs.panorama.style.top = "12px";
    },
    showChangeMap: function (el) {
      this.$refs.changeMapStyle.style.width = "269px";
      this.$refs.hybrid.style.right = "192px";
      this.$refs.normal.style.right = "102px";
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/mapCss/MapStyle.css";
</style>



// WEBPACK FOOTER //
// src/components/mapContent/MapStyle.vue